"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadXxxl = exports.PadXxl = exports.PadXl = exports.PadL = exports.PadM = exports.PadS = exports.PadXs = void 0;
exports.PadXs = "2px";
exports.PadS = "4px";
exports.PadM = "6px";
exports.PadL = "8px";
exports.PadXl = "10px";
exports.PadXxl = "12px";
exports.PadXxxl = "16px";
